import { render } from "./SchemaRelationResult.vue?vue&type=template&id=19b3a260"
import script from "./SchemaRelationResult.vue?vue&type=script&lang=js"
export * from "./SchemaRelationResult.vue?vue&type=script&lang=js"
script.render = render

export default script